import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

const SectionContainer = styled('section')`
  position: relative;
  padding: 16px 0;
  border-top: 1px solid ${({ theme }) => theme.colors.borderLight};

  &:first-of-type {
    border-top: none;
    padding-top: 0;
  }
`;

const SectionHeaderRow = styled('div')`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 12px;
`;

const SectionTitle = styled('h3')`
  margin: 0;
  font-family: 'Nunito Sans';
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  color: ${({ theme }) => (theme.isDark ? theme.colors.textSecondary : theme.colors.textStrong)};
`;

export const HelperText = styled('div')`
  margin-top: 8px;
  font-family: 'Nunito Sans';
  font-size: 13px;
  color: ${({ theme }) => theme.colors.textSecondary};
`;

const CopySection = ({
  id, title, headerControl, children,
}) => (
  <SectionContainer aria-labelledby={id}>
    <SectionHeaderRow>
      <SectionTitle id={id}>{title}</SectionTitle>
      {headerControl}
    </SectionHeaderRow>
    {children}
  </SectionContainer>
);

CopySection.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  headerControl: PropTypes.node,
  children: PropTypes.node.isRequired,
};

CopySection.defaultProps = {
  headerControl: null,
};

export default CopySection;
